<template>
  <custom-dialog width="450px" :title="model.title" :visible="visible" v-on="$listeners" class="approval-cc-node-dialog" :append-to-body="true">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item>
          <el-radio-group v-model="approvalType">
            <el-radio :label="1">{{ $t('base_approval_cc_node_dialog.zhi_ding_yong_hu') }}</el-radio>
            <el-radio :label="2">{{ $t('base_approval_cc_node_dialog.zu_zhi_gang_wei') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="approvalType === 1">
          <el-form-item>
            <el-tag v-for="(tag, index) in tags" :key="index">
              {{ tag }}
            </el-tag>
            <el-button @click="addUser">{{ $t('base_approval_cc_node_dialog.qing_xuan_ze_yong_hu') }}</el-button>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item :label="$t('base_approval_cc_node_dialog.csrsszz')" prop="approvalOrgType">
            <custom-select code="approval_org_type" v-model="form.approvalOrgType" @change="updateApprovalData" :multiple="true"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('base_approval_cc_node_dialog.csrgw')" prop="approvalRole">
            <custom-select
              ref="approvalRole"
              :auto="model.type !== 'edit'"
              url="RoleApproveList"
              v-model="form.approvalRole"
              :props="{ label: 'roleName', value: 'roleCode' }"
              @getList="approvalRoleList = $event"
            ></custom-select>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <select-user-dialog v-if="dialog1Visible" @close="dialog1Visible = false" :model="dialog1Model" @confirm="onUserUpdate"></select-user-dialog>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';
import selectUserDialog from './select_user_dialog';

export default {
  mixins: [dialogMixins],
  components: { selectUserDialog },
  data() {
    return {
      userNodes: [],
      // 选择用户
      dialog1Visible: false,
      dialog1Model: {},
      // 审批类型
      approvalType: 1,
      approvalRoleList: [],
      form: {
        flowNodeId: '',
        // 节点名称
        flowNodeName: '',
        // 节点性质
        approverPerm: '',
        // 审批人所属组织
        approvalOrgType: '',
        // 审批人所属岗位(审批角色)
        approvalRole: '',

        // 多人审批时采用的审批方式
        // multApprovalWay: 1,
        // 审批人为空时,
        // emptyType: 1

        // 选择用户信息
        approverIds: '',
        approverNames: '',

        lostHandling: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        flowNodeName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        approverPerm: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        approvalOrgType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        approvalRole: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
    tags() {
      return this.form.approverNames ? this.form.approverNames.split(',') : [];
    },
  },
  watch: {
    approvalType: {
      immediate: true,
      handler(val) {
        if (val) {
          this.updateApprovalData();
        }
      },
    },
  },
  methods: {
    updateApprovalData() {
      setTimeout(() => {
        if (this.$refs.approvalRole) {
          this.$refs.approvalRole.getSelectList();
        }
      }, 1000);
    },
    // 当前版本只支持 审批 [{code:'rw',name: '审批'},{code:'r',name: '查看'},{code:'transfer',name: '转审'}]
    approverPermSelectFilter(list) {
      return list.filter((item) => item.code === 'rw');
    },
    onUserUpdate(userNodes) {
      this.userNodes = userNodes;
      this.form.approverIds = userNodes.map((item) => item.bizId).join(',');
      this.form.approverNames = userNodes.map((item) => item.bizName).join(',');
    },
    addUser() {
      this.dialog1Model = {
        title: this.$t('base_approval_cc_node_dialog.xuan_ze_yong_hu'),
        type: 'add',
        data: {
          selectedNodeIds: this.form.approverIds.split(','),
        },
      };
      this.dialog1Visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.approvalType === 1 && this.tags.length === 0) {
            this.$message.error(this.$t('base_approval_cc_node_dialog.qing_xuan_ze_yong_hu'));
            return;
          }
          const reqData = this.getRequsetData();
          this.$postJSON(apis.apsWorkflowNodeCopySend, reqData, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.closeDialog();
            this.$emit(this.model.type, reqData);
          });
        }
      });
    },
    getRequsetData() {
      const ret = {
        workflowId: this.model.data.workflowId,
        flowNodeName: this.$t('base_approval_cc_node_dialog.chao_song'),
        flowNodeId: this.form.flowNodeId,
        approverPerm: 2,
        lostHandling: this.form.lostHandling,
      };
      if (this.approvalType === 1) {
        // ret.approverIds = this.form.approverIds;
        if (this.userNodes.length) {
          ret.approverIds = this.userNodes.map((item) => item.userId).join(',');
        } else if (this.form.approverIds) {
          ret.approverIds = this.form.approverIds;
        } else {
          ret.approverIds = '';
        }
        ret.approverNames = this.form.approverNames;
        // 清除数据
        ret.approvalOrgType = '';
        ret.approvalRole = '';
        ret.approvalRoleName = '';
      } else {
        const approvalRole = this.approvalRoleList.find((item) => item.roleCode === this.form.approvalRole);
        ret.approvalOrgType = this.form.approvalOrgType.join(',');
        ret.approvalRole = this.form.approvalRole;
        ret.approvalRoleName = approvalRole.roleName;
        // 清除数据
        ret.approverIds = '';
        ret.approverNames = '';
      }
      return ret;
    },
    initData() {
      if (this.model.type === 'edit') {
        this.$getJSON(`${apis.apsWorkflowNodeInfo}/${this.model.data.flowNodeId}`).then((res) => {
          this.$setFormatData(this.form, res.data);
          if (res.data.approvalOrgType) {
            this.form.approvalOrgType = res.data.approvalOrgType.split(',');
          }
          if (this.form.approvalRole || (this.form.approvalOrgType && this.form.approvalOrgType.length)) {
            this.approvalType = 2;
          }
        });
      }
    },
  },
  mounted() {
    this.getDicMap('bas_org_type', () => {
      this.initData();
    });
  },
};
</script>

<style lang="scss">
.approval-cc-node-dialog {
  .el-tag--small {
    margin-right: 10px;
  }
  .vertical-radio {
    .el-radio {
      display: block;
      line-height: 34px;
    }
  }

  .el-tag {
    margin-right: 15px;
  }
}
</style>
